import {useMemo} from 'react'
import {useGameStore} from '../../store/GameStoreContext.ts'
import {CardEnum, type CardStateUnordered} from '@colonist/game-states'
import {useMechanicValidatorDevelopmentCard} from '../../store/selectors/useMechanicValidatorDevelopmentCard.ts'
import {useMechanicValidatorProgressCards} from '../../store/selectors/useMechanicValidatorProgressCards.ts'

export const useBankCardState = () => {
    const resourceCards = useGameStore((state) => state.gameState.bankState.resourceCards)
    const developmentCards = useMechanicValidatorDevelopmentCard()
    const progressCards = useMechanicValidatorProgressCards()

    return useMemo<CardStateUnordered>(() => {
        const result: CardStateUnordered = {...resourceCards}
        if(developmentCards) {
            result[CardEnum.DevelopmentBack] = developmentCards.getTotalDevelopmentCardsInBank()
        }

        if(progressCards) {
            result[CardEnum.ProgressCardBack] = progressCards.bankProgressCards.getNumberOfCardsInInventory()
        }

        return result
    }, [resourceCards, developmentCards, progressCards])
}
